import { ContentTypeEnum } from 'constants-content';
import { ContentType } from 'graphql-query-contracts';

/**
 * Maps ContentTypeEnum to GraphQL ContentType.
 * This ensures type safety when converting between the application's
 * ContentTypeEnum and the GraphQL-generated ContentType.
 */
export function toGraphQLContentType(
  contentType: ContentTypeEnum
): ContentType {
  switch (contentType) {
    case ContentTypeEnum.Static:
      return ContentType.Static;
    case ContentTypeEnum.Content:
      return ContentType.Content;
    case ContentTypeEnum.Notice:
      return ContentType.Notice;
    case ContentTypeEnum.ScheduledNotice:
      return ContentType.ScheduledNotice;
    case ContentTypeEnum.ScheduledContent:
      return ContentType.ScheduledContent;
    case ContentTypeEnum.Promotion:
      return ContentType.Promotion;
    case ContentTypeEnum.Perk:
      return ContentType.Perk;
    case ContentTypeEnum.WorkOrder:
      return ContentType.WorkOrder;
    case ContentTypeEnum.VisitorManagement:
      return ContentType.VisitorManagement;
    default:
      throw new Error(`Unhandled ContentType: ${contentType}`);
  }
}

/**
 * Maps GraphQL ContentType to ContentTypeEnum.
 * This ensures type safety when converting from the GraphQL-generated
 * ContentType to the application's ContentTypeEnum.
 */
export function fromGraphQLContentType(
  contentType: ContentType
): ContentTypeEnum {
  switch (contentType) {
    case ContentType.Static:
      return ContentTypeEnum.Static;
    case ContentType.Content:
      return ContentTypeEnum.Content;
    case ContentType.Notice:
      return ContentTypeEnum.Notice;
    case ContentType.ScheduledNotice:
      return ContentTypeEnum.ScheduledNotice;
    case ContentType.ScheduledContent:
      return ContentTypeEnum.ScheduledContent;
    case ContentType.Promotion:
      return ContentTypeEnum.Promotion;
    case ContentType.Perk:
      return ContentTypeEnum.Perk;
    case ContentType.WorkOrder:
      return ContentTypeEnum.WorkOrder;
    case ContentType.VisitorManagement:
      return ContentTypeEnum.VisitorManagement;
    default:
      throw new Error(`Unhandled ContentType: ${contentType}`);
  }
}
